const APIBaseUrl = "https://maintenance-back.devolie.fr/api";
const APIFiles = "https://maintenance-back.devolie.fr";

export {APIBaseUrl, APIFiles};